import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase, FirebaseListObservable } from "angularfire2/database-deprecated";
import { Router } from '@angular/router';

import { AuthService } from '../services/AuthService'
import { BuyService } from '../services/buyservice'

@Injectable()
export class MemberService {

    constructor(public afAuth: AngularFireAuth, public router: Router, private afdb: AngularFireDatabase, public auth: AuthService, public buy: BuyService) {

    }
    getItemHistory(id) {
        let historyUser: any[] = [];
        let itemHistory = this.buy.gethistory();
        itemHistory.subscribe((snap) => {
            historyUser = [];
            for (var i = 0; i < snap.length; i++) {
                if (snap[i].id == this.auth.email) {
                    historyUser.push(snap[i])
                }
            }
        })
        return historyUser[id]
    }

}


// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/services/memberService.ts